import React from "react";
import { Link } from "react-router";
import { Container, Header, List } from "semantic-ui-react";

function Editor() {
  return (
    <Container fluid>
      <Header as="h2" textAlign="center">
        API Specification Editor
      </Header>
      <Header dividing>Introduction</Header>
      The{" "}
      <Link to="/developer-tools/api-specification-editor">
        API Specification Editor
      </Link>{" "}
      is a powerful tool designed to simplify the development of API
      documentation and promote an API-first approach to design. It allows
      developers to create, edit, and validate API specifications in real-time,
      supporting both OpenAPI (for REST APIs) and AsyncAPI (for event-based
      APIs) standards.
      <Header dividing>Features</Header>
      <List as="ul">
        <List.Item as="li">
          <b>Dual-Pane Interface</b>
          <List as="ul">
            <List.Item>
              Left Side: Text editor for writing API specifications.
            </List.Item>
            <List.Item>
              Right Side: Real-time rendering of your content and error
              messages.
            </List.Item>
          </List>
        </List.Item>
        <List.Item as="li">
          <b>Supports OpenAPI and AsyncAPI</b>
          <List as="ul">
            <List.Item>
              Write specifications for both RESTful and event-based APIs.
            </List.Item>
          </List>
        </List.Item>
        <List.Item as="li">
          <b>Real-Time Linting with Spectral</b>
          <List as="ul">
            <List.Item>
              Immediate feedback on syntax and structural errors.
            </List.Item>
          </List>
        </List.Item>
        <List.Item as="li">
          <b>Automatic File Type Detection</b>
          <List as="ul">
            <List.Item>
              Backend automatically identifies if your content is JSON or YAML.
            </List.Item>
            <List.Item>
              Stores the specification in the correct format accordingly.
            </List.Item>
            <List.Item>Only JSON and YAML formats are accepted.</List.Item>
          </List>
        </List.Item>
        <List.Item as="li">
          <b>Backend Classification</b>
          <List as="ul">
            <List.Item>
              Automatically sorts saved specifications under REST or Event-Based
              categories.
            </List.Item>
          </List>
        </List.Item>
        <List.Item as="li">
          <b>Unique URL Generation</b>
          <List as="ul">
            <List.Item>
              Share your API documentation easily via a unique URL.
            </List.Item>
          </List>
        </List.Item>
      </List>
      <Header dividing> How to Use the API Specification Editor?</Header>
      <List as="ol">
        <List.Item as="li">
          <b>Write Your Specification</b>
          <List as="ol">
            <List.Item as="li">
              Begin typing your API specification in either YAML or JSON format.
            </List.Item>
            <List.Item as="li">
              Supports both OpenAPI and AsyncAPI standards.
            </List.Item>
          </List>
        </List.Item>
        <List.Item as="li">
          <b>View Real-Time rendering and linting</b>
          <List as="ol">
            <List.Item as="li">
              Displays a live preview of your API documentation.
            </List.Item>
            <List.Item as="li">
              Shows error messages detected by Spectral linting.
            </List.Item>
            <List.Item as="li">
              Errors are highlighted with the line numbers and detailed for easy
              correction.
            </List.Item>
            <List.Item as="li">
              Click on the line number to jump to the error in the documentarion
              in the left side.
            </List.Item>
          </List>
        </List.Item>
        <List.Item as="li">
          <b>Fix the errors</b>
          <List as="ol">
            <List.Item as="li">
              Review error messages on the right side.
            </List.Item>
            <List.Item as="li">
              Correct errors in the left-side text editor.
            </List.Item>
            <List.Item as="li">
              Ensure the specification is error-free before proceeding.
            </List.Item>
          </List>
        </List.Item>
        <List.Item as="li">
          <b>Validate against Ikano spectral ruleset</b>
          <List as="ol">
            <List.Item as="li">
              Click on <i>Validate against Ikano ruleset button</i> to validate
              you specification against Ikano's spectral ruleset.
            </List.Item>
            <List.Item as="li">
              You will see the errors in the right side if there is any.
              Otherwise a message 'Input is valid' will be shown.
            </List.Item>
            <List.Item as="li">
              But it doesn't stop you from saving your file.
            </List.Item>
          </List>
        </List.Item>
        <List.Item as="li">
          <b>Save you specification file</b>
          <List as="ol">
            <List.Item as="li">
              Click the Save button once your specification is complete.
            </List.Item>
            <List.Item as="li">
              Provide a name for your file when prompted.
            </List.Item>
            <List.Item as="li">
              File name should be unique among the other files and should only
              have alphanumericals, '-' and '_'.
            </List.Item>
            <List.Item as="li">
              If you give spaces, they will be taken as '-'.
            </List.Item>
            <List.Item as="li">
              Automatically detects whether your content is JSON or YAML and
              stores it in the corresponding format.
            </List.Item>
            <List.Item as="li">
              Classifies it under REST or Event-Based in the sidebar based on
              the specification type.
            </List.Item>
          </List>
        </List.Item>
        <List.Item as="li">
          <b>Access and share Your Documentation</b>
          <List as="ol">
            <List.Item as="li">
              Upon successful saving, a unique URL is generated for your
              specification. Use this URL to share your API documentation with
              others.
            </List.Item>
            <List.Item as="li">
              Your specification is listed under the appropriate category (REST
              or Event-Based) in the sidebar.
            </List.Item>
          </List>
        </List.Item>
      </List>
    </Container>
  );
}

export default Editor;
